module.exports = __webpack_public_path__ + "assets/img/00021.4707c895.png";